import React from "react";
import styled, { keyframes } from "styled-components";

interface Props {
  isLost: boolean;
}

const show = keyframes`
	0% {
		opacity: 0.1;
	}
	100% {
		opacity: 100;
    }
`;

const Heading = styled.div`
  font-size: 5rem;
  position: absolute;
  top: 0px;
  bottom: 0px;
  left: 0px;
  right: 0px;
  display: flex;
  justify-content: center;
  align-items: center;
  font-weight: bold;
  opacity: 0;
  animation: ${show} 2s linear forwards;
`;

const StyledWinAnimation = styled.div`
  position: absolute;
  top: 0px;
  bottom: 0px;
  left: 0px;
  right: 0px;
  z-index: 200;
  max-width: 100vw;
  max-height: 100vh;
  overflow: hidden;
  background: rgba(0, 0, 0, 0.9);
  opacity: 0;
  animation: ${show} 2s linear forwards;

  .conf0 {
    fill: #d3d3d3;
  }
  .conf1 {
    fill: #333333;
  }
  .conf2 {
    fill: #696969;
  }
  .conf3 {
    fill: #808080;
  }
  .conf4 {
    fill: #696969;
  }
  .conf5 {
    fill: #808080;
  }
  .conf6 {
    fill: #d3d3d3;
  }

  .confetti-cone {
    transform: rotate(30deg);
    transform-origin: 200px 50px;
  }
`;

const WinAnimation = ({ isLost }: Props) => {
  const [isVisible, setIsVisible] = React.useState(true);

  if (isLost && isVisible) {
    return (
      <StyledWinAnimation onClick={() => setIsVisible(false)}>
        <Heading>{"Today was not the day"}</Heading>

        <svg version="1.1" id="Layer_1" x="0px" y="0px" viewBox="0 0 800 800">
          <g className="confetti-cone">
            <path
              className="conf0"
              d="M131.5,172.6L196,343c2.3,6.1,11,6.1,13.4,0l65.5-170.7L131.5,172.6z"
            />
            <path
              className="conf1"
              d="M131.5,172.6L196,343c2.3,6.1,11,6.1,13.4,0l6.7-17.5l-53.6-152.9L131.5,172.6z"
            />

            <path
              className="conf2"
              d="M274.2,184.2c-1.8,1.8-4.2,2.9-7,2.9l-129.5,0.4c-5.4,0-9.8-4.4-9.8-9.8c0-5.4,4.4-9.8,9.9-9.9l129.5-0.4
     				c5.4,0,9.8,4.4,9.8,9.8C277,180,275.9,182.5,274.2,184.2z"
            />
            <polygon
              className="conf3"
              points="231.5,285.4 174.2,285.5 143.8,205.1 262.7,204.7 			"
            />
            <path
              className="conf4"
              d="M166.3,187.4l-28.6,0.1c-5.4,0-9.8-4.4-9.8-9.8c0-5.4,4.4-9.8,9.9-9.9l24.1-0.1c0,0-2.6,5-1.3,10.6
     				C161.8,183.7,166.3,187.4,166.3,187.4z"
            />
            <ellipse
              transform="matrix(0.7071 -0.7071 0.7071 0.7071 -89.8523 231.0278)"
              className="conf2"
              cx="233.9"
              cy="224"
              rx="5.6"
              ry="5.6"
            />
            <path
              className="conf5"
              d="M143.8,205.1l5.4,14.3c6.8-2.1,14.4-0.5,19.7,4.8c7.7,7.7,7.6,20.1-0.1,27.8c-1.7,1.7-3.7,3-5.8,4l11.1,29.4
     				l27.7,0l-28-80.5L143.8,205.1z"
            />
            <path
              className="conf2"
              d="M169,224.2c-5.3-5.3-13-6.9-19.7-4.8l13.9,36.7c2.1-1,4.1-2.3,5.8-4C176.6,244.4,176.6,231.9,169,224.2z"
            />
            <ellipse
              transform="matrix(0.7071 -0.7071 0.7071 0.7071 -119.0946 221.1253)"
              className="conf6"
              cx="207.4"
              cy="254.3"
              rx="11.3"
              ry="11.2"
            />
          </g>
        </svg>
      </StyledWinAnimation>
    );
  } else {
    return <div></div>;
  }
};

export default WinAnimation;
